import { API } from "@/lib/api";

/** Akcje presigned flow skanów: rezerwacja klucza + PUT, potwierdzenie, potwierdzenie usunięcia. */
export type PaperScanPresignAction = "presign" | "complete" | "complete-delete";

/**
 * Adres endpointu skanów umowy papierowej (ASMMNT-83, etap 2). Bez tokenu w query —
 * to endpointy Cognito, nagłówki dokleja `AuthInterceptor`.
 */
export const buildPaperScanPresignUrl = (
  agreementId: string,
  action: PaperScanPresignAction,
): string => `${API.Agreements}/${agreementId}/paper-scans/${action}`;
